import React from 'react';
import classnames from 'classnames';
import { useTranslation } from 'react-i18next';
import { Props as BaseButtonProps } from '../../Buttons/PlainButtonOrLink';
import { sanitizeHref } from "@wix/da-url";

import s from './SeeAllSlide.scss';

export interface Props {
  style?: React.CSSProperties;
  title?: string;
  seeAllUrl?: string;
  component?: any;
  containerClassName?: string;
  onClick?: () => void;
}

const SeeAllSlide: React.FC<Props & BaseButtonProps> = ({
  title,
  style,
  seeAllUrl,
  component: ButtonComponent,
  containerClassName,
  ...props
}) => {
  const { t } = useTranslation();
  const contex = (
    <div
      className={classnames(
        s['see-all-slide'],
        'ds-surface-secondary',
        containerClassName
      )}
      style={style}
    >
      <span>{title || t('common.seeAll')}</span>
    </div>
  );
  return ButtonComponent ? (
    <ButtonComponent {...props}>{contex}</ButtonComponent>
  ) : (
    <a href={sanitizeHref(seeAllUrl)}>{contex}</a>
  );
};

export default SeeAllSlide;
